export enum AuditTypeEnum {
  ADD = 1,
  UPDATE = 2,
  DELETE = 3,
  LOGIN = 4,
  LOGOUT = 5,
  LISTEN = 6,
  DOWNLOAD = 7,
}
